import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ScrollableFilterBar } from './ScrollableFilterBar';
import { NavRenderer } from './NavRenderer';
import { useChildComponentExtractor } from './useChildComponentExtractor';

/**
 * @param {object} props - Props.
 * @returns {React.Element} Component.
 */
export const StatsSectionNav = (props) => {
    const [areFilterOptionsVisible, setAreFilterOptionsVisible] =
        useState(false);

    const filterBarRef = useRef(null);
    const [resetFilterBtnStyles, setResetFilterBtnStyles] = useState(false);

    const {
        navItems,
        scrollableItems,
        filterItems,
        additionalNavItems,
        roundButtons,
        settingsButton,
        responsiveRowItems
    } = useChildComponentExtractor(props.children);

    const isFiltersVisibleHandler = () => {
        setAreFilterOptionsVisible((prev) => !prev);
    };

    const scrollableFilterBarWrapper = () => (
        <ScrollableFilterBar
            settingsButton={settingsButton}
            roundButtons={roundButtons}
            scrollableItems={scrollableItems}
            navItems={navItems}
            additionalNavItems={additionalNavItems}
            areFilterOptionsVisible={areFilterOptionsVisible}
            filterBarRef={filterBarRef}
        />
    );

    const renderNavItems = (
        <NavRenderer
            navItems={navItems}
            filterItems={filterItems}
            settingsButton={settingsButton}
            additionalNavItems={additionalNavItems}
            roundButtons={roundButtons}
            isFiltersVisibleHandler={isFiltersVisibleHandler}
            withScrollableFilter={props.withScrollableFilter}
            useRefinedFilter={props.useRefinedFilter}
            areFilterOptionsVisible={areFilterOptionsVisible}
            resetFilterBtnStyles={resetFilterBtnStyles}
            setResetFilterBtnStyles={setResetFilterBtnStyles}
        />
    );

    return (
        <div className="u-stats-shadow" style={{ marginBottom: '1.6rem' }}>
            <div className="stats-leaders-nav">
                {props.withScrollableFilter
                    ? scrollableFilterBarWrapper()
                    : renderNavItems}
            </div>

            <div
                className={`${
                    !areFilterOptionsVisible && !props.showFilterItems
                        ? 'u-hide'
                        : ''
                }`}
            >
                {filterItems &&
                    !props.useRefinedFilter &&
                    React.cloneElement(filterItems, {
                        isFiltersVisibleHandler: isFiltersVisibleHandler,
                        setResetFilterBtnStyles: setResetFilterBtnStyles
                    })}
            </div>

            {!!responsiveRowItems && (
                <div className="stats-leaders-nav__responsive-row-items">
                    {responsiveRowItems}
                </div>
            )}
        </div>
    );
};

StatsSectionNav.defaultProps = {
    name: 'StatsSectionNav'
};

StatsSectionNav.propTypes = {
    children: PropTypes.any,
    onclick: PropTypes.func,
    isOpen: PropTypes.bool,
    showFilterItems: PropTypes.bool,
    useRefinedFilter: PropTypes.bool,
    withScrollableFilter: PropTypes.bool
};
